export default {
      id: "common__car-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__car",
      toString: function () {
        return this.url;
      }
    }